import httpService from '~/utils/http';

export const getSidebarDataApi = async (param) => await httpService({
  url: '/api/site/demopage/category/listByPathName',
  data: param
});

export const getCodeApi = async (param) => await httpService({
  url: '/api/site/demopage/article/content',
  data: param
});

export const getDemoIdApi = async (param) => await httpService({
  url: '/api/site/demopage/article/list',
  data: param
});

export const getCategoryInfoApi = async (param) => await httpService({
  url: '/api/site/demopage/category/infoByPathName',
  data: param
});

